export const endpoints = [
  'service-available',
  'build-commenced',
  'coming-soon'
]

export const availablePolygonTypes = [
  'ServiceAvailable',
  'BuildCommenced',
  'ComingSoon'
]
